"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrecheckSchema = exports.SuccessSchema = exports.ErrorSchema = exports.BodySchema = exports.method = exports.path = exports.action = void 0;
exports.parseBody = parseBody;
exports.resp_err = resp_err;
exports.resp_success = resp_success;
exports.resp_precheck = resp_precheck;
const zod_1 = require("zod");
const common_1 = require("../../../../common");
const lingo2_models_1 = require("lingo2-models");
const common_2 = require("../../../../common");
/** относительно `${config.http.webAuthUrl}` */
exports.action = 'signup';
exports.path = 'signup';
exports.method = common_1.HttpMethod.PUT;
// #region Request
exports.BodySchema = zod_1.z.object({
  precheck: zod_1.z.boolean().default(false).optional(),
  accept_sla: common_2.BasicEULA,
  teacher_status: zod_1.z.nativeEnum(lingo2_models_1.TeacherStatusEnum).default(lingo2_models_1.TeacherStatusEnum.not_teacher).optional(),
  audience: common_2.BasicAudience,
  password: common_2.BasicPassword,
  email: common_2.BasicEmail,
  slug: common_1.BasicSlug.optional(),
  mobile_phone: common_2.BasicPhone,
  first_name: common_1.BasicFirstname,
  last_name: common_1.BasicLastname,
  country_id: common_1.BasicCountry
});
function parseBody(dto) {
  return exports.BodySchema.parse(dto);
}
// #endregion
// #region Response
exports.ErrorSchema = zod_1.z.object({
  reference: zod_1.z.string().optional(),
  message: zod_1.z.string(),
  details: zod_1.z.string().optional()
});
function resp_err(dto) {
  return exports.ErrorSchema.parse(dto);
}
exports.SuccessSchema = zod_1.z.object({
  access: zod_1.z.string(),
  refresh: zod_1.z.string(),
  id: zod_1.z.string().uuid().optional(),
  slug: zod_1.z.string().optional(),
  first_name: zod_1.z.string().optional(),
  last_name: zod_1.z.string().optional()
});
function resp_success(dto) {
  return exports.SuccessSchema.parse(dto);
}
exports.PrecheckSchema = zod_1.z.object({
  exist: zod_1.z.boolean().default(false)
});
function resp_precheck(dto) {
  return exports.PrecheckSchema.parse(dto);
}
// #endregion
